module.exports = __webpack_public_path__ + "static/media/Beards.734c4c46.png";